const Loader = () => {
  return (
    <div className="loading-page" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <div className="spinner"></div>
      <span>Loading...</span>
    </div>
  );
};

export default Loader;
